const mostFrequent = (arr) => {
  //Store the number counts in object
  const count = arr.reduce((a, b) => {
    if (!a[b]) {
      a[b] = 1;
    } else {
      a[b]++;
    }

    return a;
  }, {});

  let minCount = Number.MIN_SAFE_INTEGER;
  let numberWithMaxCount = -1;

  //Find the number with max count
  for (const [key, value] of Object.entries(count)) {
    if (value >= minCount) {
      minCount = value;
      numberWithMaxCount = key;
    }
  }

  return numberWithMaxCount;
};

export default mostFrequent;
